import { createApiV2 } from "./common";

export const markNotificationAsRead = (data) => (token) =>
  createApiV2("POST", "notifications/mark-read/")(token, data);

export const markAllNotificationsAsRead = () => (token) =>
  createApiV2("POST", "notifications/mark-all-read/")(token);

export const markCustomEventReminderAsRead = (data) => (token) =>
  createApiV2("POST", "custom-event-reminders/mark-read/")(token, data);

export const markAllCustomEventRemindersAsRead = () => (token) =>
  createApiV2("POST", "custom-event-reminders/mark-all-read/")(token);

export const markAllPONotificationsAsRead = () => (token) =>
  createApiV2("POST", "purchase-order-notifications/mark-all-read/")(token);
